import { fontSizes, fontWeights, lineHeight } from '@ohgoodlord/design-system'
import styled from 'styled-components'

const FastestBadge = styled.span`
  display: inline-flex;
  align-items: center;
  background: #3adfc0;
  border-radius: 3px;
  padding: 1.5px 6px;
  font-size: ${fontSizes.xs};
  font-weight: ${fontWeights.bold};
  line-height: ${lineHeight};
  letter-spacing: 0.57px;
  text-transform: uppercase;
  color: #08302a;
  white-space: nowrap;
`

export const FastestTag = () => {
  return <FastestBadge>Fastest</FastestBadge>
}
